import { Component, OnInit } from '@angular/core';
import { AppSpinnerService } from 'src/app/services/app-spinner.service';

@Component({
  selector: 'app-no-record',
  templateUrl: './no-record.component.html',
  styleUrls: ['./no-record.component.scss']
})
export class NoRecordComponent implements OnInit {

  constructor(public appSpinnerService: AppSpinnerService) { }

  ngOnInit() {
  }

}
